import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import '../index.css'; // Ensure the CSS file is imported

const ButtonCellRenderer = (props) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(props.data.order_status);

  const handleClickOpen = (event) => {
    event.stopPropagation(); // Stop event propagation
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (status !== props.data.order_status) {
      props.context.updateOrderStatus(props.data.id, status);
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        style={{ minWidth: '60px', padding: '4px 8px', fontSize: '12px' }} // Inline styles to reduce size
        onClick={handleClickOpen}
        className="button-cell" // Apply the CSS class
      >
        Move
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Change Order Status</DialogTitle>
        <DialogContent
          sx={{
            overflow: 'visible', // Allow dropdown to overflow if needed
            pb: 2,
            pt: 1,
            minWidth: 300
          }}
        >
          <FormControl
            fullWidth
            margin="dense"
            sx={{
              mt: 2,
              background: '#232323',
              borderRadius: 1,
              zIndex: 1301, // Above dialog
            }}
          >
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
              MenuProps={{
                PaperProps: {
                  sx: {
                    zIndex: 1400 // Ensure dropdown is above dialog
                  }
                }
              }}
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            sx={{
              color: '#fff',
              minWidth: '60px',
              px: 2,
              fontSize: '12px'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            sx={{
              color: '#fff',
              minWidth: '60px',
              px: 2,
              fontSize: '12px'
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ButtonCellRenderer;
